import { useContext } from 'react';
import { AssignmentReturnedOutlined } from '@mui/icons-material';

import { Report } from '../../interfaces';
import ActionItem from '../utils/tableActionTrigger';
import { HandleDownloadReport } from '../interfaces';
import { LocalesContext } from '../../localesContext';
import { useDownloadReport } from './useDownloadReport';

interface Props {
  item: Report;
  handleDownloadReport: HandleDownloadReport;
}
const DownloadAction = ({ item, handleDownloadReport: downloadFile }: Props) => {
  const locales = useContext(LocalesContext);
  
  const size = 'reportFileSize' in item ? (item.reportFileSize as number) : undefined;

  const { handleDownloadReport } = useDownloadReport({
    id: item.id,
    name: item.name,
    size,
    downloadFile
  });
  return (
    <ActionItem onClick={handleDownloadReport} item={item} tooltip={locales.tooltip.download}>
      <AssignmentReturnedOutlined data-testid="download" cursor="pointer" />
    </ActionItem>
  );
};

export default DownloadAction;
